import { AxiosResponse } from "axios";
import { AuthResponse, User, AdminUser, Plano, PlanoCreateInput, PlanoUpdateInput, PaginationParams } from "@/types";
import api from "../httpClient";
import { fetchAll, fetchById, create, update, deleteById } from "../apiHelpers";

export const authService = {
  login: async (email: string, senha: string): Promise<AuthResponse> => {
    const response = await api.post<{ token: string; usuario?: User; user?: User }>("/usuario/login", {
      email,
      senha,
    });
    const d = response.data;
    return { token: d.token, user: (d.user ?? d.usuario) as User };
  },

  loginAdmin: async (email: string, senha: string): Promise<AuthResponse> => {
    const response = await api.post<{ token: string; usuario?: User; user?: User }>("/usuario/login-admin", {
      email,
      senha,
    });
    const d = response.data;
    return { token: d.token, user: (d.user ?? d.usuario) as User };
  },

  register: async (nome: string, email: string, senha: string, telefone?: string, cargo?: string): Promise<User> => {
    const response: AxiosResponse<User> = await api.post("/usuario/cadastro-publico", {
      nome,
      email,
      telefone,
      cargo,
      senha,
    });
    return response.data;
  },

  changePassword: async (id: number, senhaAtual: string, novaSenha: string): Promise<void> => {
    await api.put(`/usuario/senha/${id}`, { senhaAtual, novaSenha });
  },

  updateProfile: async (_id: number, data: { nome?: string; email?: string; telefone?: string | null; cargo?: string | null }): Promise<User> => {
    const response: AxiosResponse<User> = await api.put("/usuario/me", data);
    return response.data;
  },

  getProfile: async (id: number): Promise<User> => {
    const response: AxiosResponse<User> = await api.get(`/usuario/${id}`);
    return response.data;
  },
};

export const planoAdminService = {
  list: async (): Promise<Plano[]> => {
    const response: AxiosResponse<Plano[]> = await api.get("/plano");
    return response.data;
  },
  getById: (id: number) => fetchById<Plano>("/plano", id),
  create: (data: PlanoCreateInput) => create<Plano>("/plano", data),
  update: (id: number, data: PlanoUpdateInput) => update<Plano>("/plano", id, data),
  delete: (id: number) => deleteById("/plano", id),
};

export const usuarioAdminService = {
  list: (filters?: PaginationParams) => fetchAll<AdminUser>("/usuario", filters),
  getById: (id: number) => fetchById<AdminUser>("/usuario", id),
  alterarPlano: async (id: number, body: { planoId: number; motivo?: string }): Promise<AdminUser> => {
    const response: AxiosResponse<AdminUser> = await api.put(`/usuario/${id}/plano`, body);
    return response.data;
  },
  alterarPerfil: async (id: number, role: 'ADMIN' | 'USUARIO'): Promise<AdminUser> => {
    const response: AxiosResponse<AdminUser> = await api.put(`/usuario/${id}`, { role });
    return response.data;
  },
};
